import { RestService, Rest, PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import {
  GetTreeDataInformationProjectionListInputDto,
  ProjectionDownloadTokenResultDto,
  TreeDataInformationProjectionDto,
  TreeDataInformationProjectionExcelDownloadDto,
} from './tree-data-information-projection.models';

@Injectable({
  providedIn: 'root',
})
export class TreeDataInformationPlanningOrchestratorService {
  private readonly restService = inject(RestService);
  private readonly apiName = 'Orchestrator';

  getList = (
    input: GetTreeDataInformationProjectionListInputDto,
    config?: Partial<Rest.Config>,
  ) =>
    this.restService.request<any, PagedResultDto<TreeDataInformationProjectionDto>>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/tree-data-informations',
        params: input,
      },
      { apiName: this.apiName, ...config },
    );

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ProjectionDownloadTokenResultDto>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/tree-data-informations/download-token',
      },
      { apiName: this.apiName, ...config },
    );

  getListAsExcelFile = (
    input: TreeDataInformationProjectionExcelDownloadDto,
    config?: Partial<Rest.Config>,
  ) =>
    this.restService.request<any, Blob>(
      {
        method: 'GET',
        responseType: 'blob',
        url: '/api/orchestrator/planning/tree-data-informations/excel',
        params: input,
      },
      { apiName: this.apiName, ...config },
    );
}

export interface TreeDataInformationPropertyOption {
  id: number;
  name: string;
}

@Injectable({ providedIn: 'root' })
export class TreeDataInformationPropertyOptionsService {
  private readonly restService = inject(RestService);

  getList = (input: {
    regionId?: number[] | string | null;
    id?: number[] | string | null;
    name?: string;
    skipCount?: number;
    maxResultCount?: number;
  }, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TreeDataInformationPropertyOption>>(
      {
        method: 'GET',
        url: '/api/orchestrator/planning/tree-data-informations/property-options',
        params: input,
      },
      { apiName: 'Orchestrator', ...config },
    );
}
